import { FC, useEffect, useState } from 'react';
import {Flex, Group, UnstyledButton, Title, Text, Switch, Tooltip } from '@mantine/core';
import { fetchSiteMap,createSiteMap, deleteSiteMap, updateSiteMap, siteMapinit, reorderSiteMap, sitemapUrlsAdd, updateSiteMapFromUrl, DeleteAllSitemap } from '../../store/sitemap';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, TextInput, Divider, Modal, AutomatedAuditLoader, Select } from '@common/components';
import { ReactComponent as EmptyTable } from 'src/assets/svg/empty-table.svg';
import { ChevronDown, ChevronsDown, ChevronsUp, Lock } from '@geist-ui/icons';
import styles from './sitemapTableStyles.module.scss';
import classNames from 'classnames';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { useAlert } from '@common/hooks';
import { AutoSizer, Column, Table } from 'react-virtualized';
import 'react-virtualized/styles.css';
import "./style.css"


interface SitemapTableProps {
    siteID: string | undefined;
    openedAccordion?: string | null;
    siteUUID?:string | null;
    companyId?:string | null;
  }
  
  const  SitemapTable: FC <SitemapTableProps> = ({siteID = '', openedAccordion , siteUUID,companyId}) => {
    

    const [t] = useTranslation('sitemap');
    const dispatch = useAppDispatch();
    const { updateSuccess, data, reorderSiteMapSuccess, sitemapUrlsAddSuccess, updateSiteMapFromUrlLoading, DeleteAllSitemapLoading } = useAppSelector((state) => state.siteMap, shallowEqual);
    const { tenantId } = useAppSelector((state) => state.user.data, shallowEqual);
    const [opened, { open, close }] = useDisclosure(false);
    const { showAlert } = useAlert();

    const selectedSitemap = openedAccordion?.replace("sitemap-", "");   
    const [editableIndex, setEditableIndex] = useState<number | null>(null); 
    const [oldUrl, setOldUrl] = useState<string>('');
    const [updatedUrl, setUpdatedUrl] = useState<string>('');  
    const [idUpdatedUrl, setIdUpdatedUrl] = useState<string>('');  
    const [actionType, setActionType] = useState<'order' | 'update' | 'delete' | 'state' | '' >('');  
    
    const showUpdateField = (index: number, url: string) => {
      setEditableIndex(index);
      setOldUrl(url); 
      setUpdatedUrl(url);
    }
  
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, idUrl: string) => {
      if(!event.target.value){return;}    

      setUpdatedUrl(event.target.value);
      setIdUpdatedUrl(idUrl);

    }
  
    const handleUpdate = (e: any, id: string) => {
      
      if (e.key === 'Enter') {
        // console.log(updatedUrl);
        if( !updatedUrl){
            return;
        }
        setActionType('update');
        dispatch(updateSiteMap({ 
            siteUUID, 
            isNewVersion: false,
            urls: [{
                "id": id,
                "newUrl": updatedUrl
              }]
          }));
      }
    }
    
    useEffect(() => { 
      if(!updateSuccess){
        return;
      }
      if(selectedSitemap != siteID){
        return; 
      }
      
      showAlert({
        id: 'updated'+pageUrl+pageId,
        title: 'Success',
        message: "The Url was updated successfully",
        variant: 'success',
      });

      updateDataSet();
      // dispatch(fetchSiteMap({ tenantId: tenantId, siteId: siteID })); 
      setEditableIndex(null);
      dispatch(siteMapinit());
    
    }, [updateSuccess]);
    
    const {  loading, createLoading, deleteSuccess, currentSitemapSiteCreating } = useAppSelector((state) => state.siteMap, shallowEqual);
    const [pageUrl, setPageUrl] = useState<string|undefined >('');
    const [addOpen, setAddOpen] = useState(false);
    const [pageId, setPageId] = useState<string>('');
    const [updateFromSitemapUrlOpen, setUpdateFromSitemapUrlOpen] = useState(false);



    const openModal = (pageUrl?: string | undefined, pageId?: string )=>{
        if(pageUrl == 'all'){
          setPageUrl(pageUrl);
          open();
          return;
        }
        
        if(!pageId){
          return;
        }
        setPageId(pageId);
        open();
      } 


      const addOpenModal = ()=>{
        
        setAddOpen(true);
      } 
      const addCloseModal = ()=>{
        setAddOpen(false);
        setNewUrl('');
      }


      const updateFromSitemapUrlOpenModal = ()=>{
        
        setUpdateFromSitemapUrlOpen(true);
      } 
      
      const updateFromSitemapUrlCloseModal = ()=>{
        setUpdateFromSitemapUrlOpen(false);
        setUpdateFromUrl('');
      }


    useEffect(() => { 
        if(!deleteSuccess){
        return;
        }
        if(selectedSitemap != siteID){
          return; 
        }
        showAlert({
          id: 'delete'+pageUrl+pageId,
          title: 'Success',
          message: "The Url was deleted successfully",
          variant: 'success',
        });
        updateDataSet();
        // dispatch(fetchSiteMap({ tenantId: tenantId, siteId: siteID }));
        setPageUrl('');
        close();
        dispatch(siteMapinit());
    
    }, [deleteSuccess]);


    useEffect(() => {

      if (!reorderSiteMapSuccess) {
        return;
      }

      if(selectedSitemap != siteID){
        return; 
      }
      showAlert({
        id: 'reorder'+pageUrl+pageId,
        title: 'Success',
        message: "The Url was reordered successfully",
        variant: 'success',
      });

      updateDataSet();
      dispatch(siteMapinit());
      // dispatch(fetchSiteMap({ tenantId: tenantId, siteId: siteID }));

    }, [reorderSiteMapSuccess]);


    useEffect(() => {
      if(!openedAccordion ){
        return;
      }
      if(selectedSitemap != siteID){
        return; 
      }
      if(dummydata[siteID]){
        return;
      }      
      dispatch(fetchSiteMap({ siteUUID }));
    }, [openedAccordion]);
    
    
    const stopEdit = () => {
      setEditableIndex(null);
      setPageUrl('');
    };
  

    // Initialize sitemapState as an array of "active" strings, one for each entry in dummydata
    
    const siteMapStateData = [
      {
        label: 'Active',
        value: 'active',
      },
      {
        label: `Don't audit`,
        value: 'dont_audit'
      }
    ];
    
    const [dummydata, setSDummydata] = useState<any>([]);

    const [newUrl, setNewUrl] = useState<any>(`${siteID}/example`);

    const [updateFromUrl, setUpdateFromUrl] = useState<any>(`${siteID}/sitemap.xml`);

    useEffect(() => {     
      if(!data || !siteUUID  || !data[siteUUID]){
        return;
      }
      
      // const transformedObject = data[siteUUID]?.reduce((acc: any, currentItem: any) => {
      //   const [key, value] = Object.entries(currentItem)[0];
      //   acc[key] = value;
      //   return acc;
      // }, {});
      // console.log('transformedObject');
      // console.log(transformedObject);
      // console.log('transformedObject');
      // if(!transformedObject){
      //     return;
      // }
      
      setSDummydata(data);
      
    }, [data]);   

    const updateDataSet = ( ) => {
      // Check if the website key exists in the state
      if (!siteUUID || !dummydata[siteUUID]) {
          return;
      }
      if(actionType == 'update'){
        // Map over the array to find the object with the matching ID and update the pageUrl
        const updatedArray = dummydata[siteUUID].map((page: any) =>
          page.id === idUpdatedUrl ? { ...page, pageUrl: updatedUrl } : page
        );
  
        // Update the state with the new array for the specific website
        setSDummydata((prevState: any) => ({
          ...prevState,
          [siteUUID]: updatedArray,
        }));
      }
      else if(actionType == 'delete'){

        const updatedArray = dummydata[siteUUID].filter((page: any) => page.id !== pageId);

        // Update the state with the new array for the specific website
        setSDummydata((prevState: any) => ({
          ...prevState,
          [siteUUID]: updatedArray,
        }));
      }
      else if(actionType == 'order'){
        
          const currentIndex = dummydata[siteUUID].findIndex(
            (page: any) => page.id === orderValue?.currentRecordId
          );
          const targetIndex = dummydata[siteUUID].findIndex(
            (page: any) => page.id === orderValue?.targetRecordId
          );
    
          if (currentIndex === -1 || targetIndex === -1) {
            console.log("One of the records not found.");
            return;
          }
    
          // Swap the 'order' values of the two objects
          const currentOrder = dummydata[siteUUID][currentIndex].order;
          const targetOrder = dummydata[siteUUID][targetIndex].order;
    
          // Update the order
          let updatedArray = dummydata[siteUUID].map((page: any, index: any) => {
            if (index === currentIndex) {
              return { ...page, order: targetOrder };
            }
            if (index === targetIndex) {
              return { ...page, order: currentOrder };
            }
            return page;
          });
    
          // Sort the updated array by the 'order' property
          updatedArray = updatedArray.sort((a: any, b: any) => a.order - b.order);
    
          // Update the state with the new array
          setSDummydata((prevState: any) => ({
            ...prevState,
            [siteUUID]: updatedArray,
          }));
    
          console.log("Order changed successfully!");
    
        }
      else if(actionType == 'state'){

        const updatedArray = dummydata[siteUUID].map((page: any) => {
          if (page.id === stateValue.id) {
            return { ...page, state: stateValue.newValue }; // Update the state property
          }
          return page; // Return the page unchanged if it's not the target
        });
  
        // Update the state with the new array
        setSDummydata((prevState: any) => ({
          ...prevState,
          [siteUUID]: updatedArray,
        }));
      }
     
    };

        
    const [stateValue, setStateValue] = useState<any>({});
    
    const [orderValue, setOrderValue] = useState<any>({});
    const changeSiteMapOrder = (currentRecordId: string, targetRecordId: string ) => {
      // console.log(currentRecordId,targetRecordId);
      
      if (!currentRecordId || !targetRecordId) {
        return;
      }
      setActionType('order');
      setOrderValue({currentRecordId,targetRecordId});
      dispatch(reorderSiteMap({ currentRecordId, targetRecordId }));
      
    };

    const sitemapUrlsAddfunc = ()=>{
      if(!validateInput(newUrl) || !siteUUID ){
          return;
      }
      const version = dummydata?.length == 0 ? 1 : dummydata[siteUUID]?.data[0]?.version     
      dispatch(sitemapUrlsAdd({  siteUUID , isNewVersion:false, versionNumber: version , urls:[{'newUrl':newUrl}] }));

    }

    const updateFromSitemapUrlFunc = ()=>{
      
      
      if(!validateInput(updateFromUrl) || !siteUUID ){
          return;
      }
      dispatch(updateSiteMapFromUrl({  siteUUID , sitemapURL:updateFromUrl}));
      updateFromSitemapUrlCloseModal();
    }


    useEffect(() => {
      if(!sitemapUrlsAddSuccess){
          return;
      }
      if(selectedSitemap != siteID){
        return; 
      }
      showAlert({
        id: 'add'+pageUrl+pageId,
        title: 'Success',
        message: "The Url added successfully",
        variant: 'success',
      });
      addCloseModal();
      dispatch(fetchSiteMap({ siteUUID }));
      dispatch(siteMapinit());

    }, [sitemapUrlsAddSuccess]);
    
    const [error, setError] = useState("");

    const validateInput = (inputValue: any) => {
      if (inputValue.trim() === "") {
        setError("Input cannot be empty");
        return false;
      } 
      setError("");
      return true;
    };
  
    const rows = siteUUID && dummydata[siteUUID] || [];
    const isMobile = useMediaQuery('(max-width: 1800px)'); // detects if viewport is mobile size
    const { paymentPlan } = useAppSelector((state) => state.payment.data);
    const isFreePlan = paymentPlan == 'free'

    const onSitemapStatechanged = (val:any,id:any) => {
        if (!val) return;
        dispatch(updateSiteMap({ 
          siteUUID, 
          isNewVersion: false,
          urls: [{
              "id": id,
              "newState": val
            }]
        }));
        setStateValue(()=>({id,newValue:val}));
        setActionType('state');
        updateDataSet();

    }

    return (
        <>
            <Flex w={'100%'} p={'20px'} >
                <Flex w={'100%'}  gap={'18px'} align={'center'} wrap={'wrap'} justify={'end'} className={classNames(styles['mob-resp'])}>

                <Button
                    ariaLabel='Delete all sitemap'
                    disabled={isFreePlan || DeleteAllSitemapLoading || !siteUUID || dummydata[siteUUID]?.length == 0}
                    loading={ DeleteAllSitemapLoading }
                    onClick={ ()=>{


                      openModal("all")
                      // if (window.confirm("Are you sure you want to delete all sitemap?")) {
                      //   dispatch(DeleteAllSitemap({  siteUUID, company_id:companyId }));

                      // }
                    }
                    }>
                        Delete all sitemap
                  </Button>

                  <Button
                    ariaLabel='Create a sitemap'
                    // disabled={createLoading }
                    loading={ (createLoading && currentSitemapSiteCreating?.includes(siteUUID ?? "")) }

                    onClick={() => {
                      dispatch(createSiteMap({  siteUUID  }));
                    }}>
                    <Flex gap={'5px'}>
                      {(createLoading && currentSitemapSiteCreating?.includes(siteUUID ?? ""))  && <Lock size={16} aria-label={`${t('lockedItem')}`} />}
                      {(createLoading && currentSitemapSiteCreating?.includes(siteUUID ?? "")) ? t('sitemapIsCreatingBtn')  : t('createSitemaptBtn') }
                    </Flex>
                  </Button>

                  

                  {/* <Button
                    // disabled={createLoading}
                    // loading={ (loading || createLoading) }
                    onClick={() => {
                        openModal('all')

                    }}>
                        Delete Sitemap
                  </Button> */}



                  <Button
                    disabled = {isFreePlan}
                    ariaLabel='Add page url'
                    onClick={() => {
                        setAddOpen(true);

                    }}>
                        <Flex gap={'5px'}>
                          {isFreePlan && <Lock size={16} aria-label="locked item" />}
                          Add Page
                        </Flex>
                  </Button>
                  <Button
                    ariaLabel='Update from sitemap url, update sitemap'
                    disabled={updateSiteMapFromUrlLoading}
                    loading={ updateSiteMapFromUrlLoading }
                    onClick={
                      updateFromSitemapUrlOpenModal
                    }>
                        Update from Sitemap URL
                  </Button>
                  {/* <Button
                    ariaLabel='Update sitemap based on sitemap URL'
                    onClick={() => {
                        setAddOpen(true);

                    }}>
                      Update Sitemap
                  </Button> */}
                
                </Flex>
              </Flex>
            <div className={classNames(styles['content-wrapper'])}>

                {siteUUID && dummydata[siteUUID]?.length ?  (
                  <Flex direction={"column"}>
                      <div style={{ height: '400px', width: '100%', overflowX: isMobile ? 'auto' : 'visible', overflowY: 'hidden' }}>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            
            width={isMobile ? Math.max(1200, width) : width}
            height={height}
            headerHeight={50}
            rowHeight={60}
            rowCount={rows.length}
            rowGetter={({ index }) => rows[index]}
            rowClassName={({ index }) =>
              index !== -1
                ? `${styles['table-row']} ${rows[index]?.state === 'dont_audit' ? styles['disabled-row'] : ''}`
                : ''
            }
            headerStyle={{
              backgroundColor: '#dae9e9',
              paddingRight:'10px',
              marginRight: "0"
            }}

          >
            <Column
              label="Audit Order"
              dataKey="id"
              width={150}
              headerRenderer={() => (
                <div className={classNames(styles['th'])}>
                  Audit Order <ChevronDown />
                </div>
              )}
              cellRenderer={({ rowIndex }) => (
                <div className={classNames(styles['table-cell'], styles['id-cell'])}>{rowIndex + 1}</div>
              )}
            />
            <Column
              label="Title"
              dataKey="title"
              width={250}
              headerRenderer={() => (
                <div className={classNames(styles['th'])}>
                  Title <ChevronDown />
                </div>
              )}
              cellRenderer={({ rowData, rowIndex }) =>  
                              <div className={classNames(styles['title-cell'])} >
                                    {rowData.title}
                              </div>}
            />
            <Column
              label="URL"
              dataKey="pageUrl"
              width={450}
              headerRenderer={() => (
                <div className={classNames(styles['th'])}>
                  URL <ChevronDown />
                </div>
              )}
              cellRenderer={({ rowData, rowIndex }) =>
              ( rowData?.title?.includes('Cloudflare') ? null :
                editableIndex === rowIndex  ? (
                  <TextInput
                    autoFocus
                    ariaLabel="Edit URL, press enter to save"
                    value={updatedUrl}
                    onChange={(e) => handleInputChange(e, rowData.id)}
                    placeholder="New URL"
                    onKeyDown={(e) => handleUpdate(e, rowData.id)}
                    onBlur={() => stopEdit()}
                  />
                ) : (
                  <div className={classNames(styles['table-cell'], styles['pageUrl-cell'])}>{rowData.pageUrl}</div>
                )
        )}
            />
            <Column
              label="Actions"
              dataKey="actions"
              width={230}
              headerRenderer={() => <div  style={{zIndex: '1'}} className={classNames(styles['th'])}>Actions</div>}
              cellRenderer={({ rowData, rowIndex }) => (
                rowData?.title?.includes('Cloudflare') ? null :
                <div className={classNames(styles['table-cell'], styles['action-cell'])}>
                  <Button disabled={isFreePlan || editableIndex === rowIndex} onClick={() => showUpdateField(rowIndex, rowData.pageUrl)}>
                        <Flex gap={'5px'}>
                          {isFreePlan && <Lock size={16} aria-label="locked item" />}
                            Edit
                        </Flex>
                  </Button>
                  <Button disabled={isFreePlan} buttonStyle={{ marginLeft: '20px' }} onClick={() => {
                      setPageUrl('')
                      openModal(rowData.pageUrl, rowData.id)}
                  } >
                    <Flex gap={'5px'}>
                      {isFreePlan && <Lock size={16} aria-label="locked item" />}
                      Delete
                    </Flex>
                    
                  </Button>
                </div>
              )}
            />
            <Column
              label="Status"
              dataKey="state"
              width={100}
              headerRenderer={() => <div className={classNames(styles['th'])}>Status</div>}
              cellRenderer={({ rowData }) => (
                rowData?.title?.includes('Cloudflare') ? null :
                <Flex gap="sm">
                  <Select
                    disabled={isFreePlan}
                    variant="secondary"
                    withIcon
                    aria-label="Change sitemap page state"
                    value={rowData.state} 
                    data={siteMapStateData}
                    icon={isFreePlan && <Lock size={16} aria-label="locked item" />}
                    onChange={(val)=>{onSitemapStatechanged(val,rowData.id)}}
                    withinPortal={true}
                  />
                </Flex>
              )}
            />
            <Column
              label=""
              dataKey="order"
              width={100}
              headerRenderer={() => <div style={{ width: '2.5rem'  }} className={classNames(styles['th'])} />}
              cellRenderer={({ rowData, rowIndex }) => (
                rowData?.title?.includes('Cloudflare') ? null :
                <div className={classNames(styles['order-cell'])}>
                  <Flex gap="sm" align="center" justify="end">
                    <Tooltip label={isFreePlan ? 'Upgrade your plan' :"Move up"} withinPortal>
                        <div aria-label='Move up'>
                          <span style={{ visibility: rowIndex !== 0 ? 'visible' : 'hidden' }}>
                            <ChevronsUp
                              onClick={() => {if(isFreePlan){return} changeSiteMapOrder(rowData.id, rows[rowIndex - 1].id)}}
                            />
                          </span>
                        </div>
                    </Tooltip>
                    <Tooltip label={ isFreePlan ? 'Upgrade your plan' : "Move down"} withinPortal>
                      <div aria-label='Move down'>
                        <span style={{ visibility: rowIndex !== rows.length - 1 ? 'visible' : 'hidden' }}>
                          <ChevronsDown
                            onClick={() => {if(isFreePlan){return} changeSiteMapOrder(rowData.id, rows[rowIndex + 1].id)}}
                          />
                        </span>
                      </div>
                    </Tooltip>
                  </Flex>
                </div>
              )}
            />
          </Table>
        )}
      </AutoSizer>
    </div>
                     {/* <Flex justify={"end"} align={"center"}>
                     <p>Last Edit 09/09/2024 at 09:30AM by <strong style={{ color :'#5b5eff'}}>Paula Wilson</strong></p>
                   </Flex> */}
                  </Flex>

                ) : (
                  <div>
                    {/* <Title size={22} order={2}>
                      {t('noSitemapYet')}
                    </Title> */}
                    <Flex
                      mih={'375px'}
                      bg={'#ffffff'}
                      direction={'column'}
                      align={'center'}
                      justify={'center'}
                      gap={'24px'}>
                      {loading ? (
                        <>
                          <AutomatedAuditLoader />
                          <Text>{t('lookingForUrls')}</Text>
                        </>
                      ) : (
                        <>
                          <EmptyTable />
                          <Text>{t('noSitemapYet')}</Text>
                        </>
                      )}
                    </Flex>
                  </div>
                )}
            </div>



    
    <Modal opened={opened} close={close} zIndex={1000} withCloseButton={false} size={416} padding={0}>
        <Group align={'center'} position={'center'} p={28}>
            <Title order={3}>{pageUrl == "all" ? "Delete the sitemap" : t('removeUrl') }</Title>
            <Text align={'left'}>
            { pageUrl == "all" ? "By deleting you will lose the sitemap related to this website." : t('modalFirstRow') }
            <br />
            { pageUrl == "all" ? "Are you sure you want to remove this sitemap?" : t('modalSecondRow')}
            </Text>
        </Group>
        <div className={classNames(styles['btn-group'])}>
            <UnstyledButton onClick={close} className={classNames(styles['action-btn'])}>
            {t('modalCancel')}
            </UnstyledButton>
            <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
            <UnstyledButton onClick={()=> { 
                                      if(pageUrl == "all"){
                                          dispatch(DeleteAllSitemap({  siteUUID, company_id:companyId }));
                                          close();
                                        }else{
                                          dispatch(deleteSiteMap({ siteUUID , pageId: pageId })); setActionType('delete'); 
                                        }
                                      
                                      }} className={classNames(styles['action-btn'])}>
            {t('modalDelete')}
            </UnstyledButton>
        </div>
    </Modal>

    <Modal opened={updateFromSitemapUrlOpen} close={updateFromSitemapUrlCloseModal} zIndex={1000} withCloseButton={false} size={616} padding={0}>
        <Group display={'block'} align={'center'} position={'center'} p={28}>
            <Title order={3}>Add Url</Title>
              <div style={{marginTop:"30px"}}>
                <TextInput
                    value= {updateFromUrl}
                    ariaLabel="Add Url"
                    placeholder={`${siteID}/sitemap.xml`}
                    label="Url"
                    onChange={(e)=>{ setUpdateFromUrl(e.target.value); }}
                    required
                />
                 {error && <p style={{ color: "red" }}>{error}</p>}
              </div>
        </Group>
        <div className={classNames(styles['btn-group'])}>
            <UnstyledButton onClick={updateFromSitemapUrlCloseModal} className={classNames(styles['action-btn'])}>
            {t('modalCancel')}
            </UnstyledButton>
            <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
            <UnstyledButton onClick={()=> updateFromSitemapUrlFunc() } className={classNames(styles['action-btn'])}>
                Save
            </UnstyledButton>
        </div>
    </Modal>



    <Modal opened={addOpen} close={addCloseModal} zIndex={1000} withCloseButton={false} size={616} padding={0}>
        <Group display={'block'} align={'center'} position={'center'} p={28}>
            <Title order={3}>Add Url</Title>
              <div style={{marginTop:"30px"}}>
                <TextInput
                    value= {newUrl}
                    ariaLabel="Add new Url"
                    placeholder={`${siteID}/sitemap.xml`}
                    label="New Url"
                    onChange={(e)=>{ setNewUrl(e.target.value); }}
                    required
                />
                 {error && <p style={{ color: "red" }}>{error}</p>}
              </div>
        </Group>
        <div className={classNames(styles['btn-group'])}>
            <UnstyledButton onClick={addCloseModal} className={classNames(styles['action-btn'])}>
            {t('modalCancel')}
            </UnstyledButton>
            <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
            <UnstyledButton onClick={()=> sitemapUrlsAddfunc() } className={classNames(styles['action-btn'])}>
                Save
            </UnstyledButton>
        </div>
    </Modal>
    </>
    );
  };

  export default SitemapTable